import { CommunityPage } from "~/types/CommunityTypes";
import { RouterOutputs } from "~/utils/api";
import {
    Card,
    CardContent,
    CardHeader,
    CardTitle,
} from "~/components/v3/shadcn/Card";
import Link from "next/link";
import { Label } from "../shadcn/Label";

export const MoreInfoTab = ({
    community,
}: {
    community?: Omit<CommunityPage, "leaders" | "topHosts">;
}) => {
    const communityLinks = community?.links
        .filter((l) => l.type !== "OFFICIAL")
        .slice(0, 3);
    return (
        <>
            <Card className="h-screen gap-3 p-0">
                <CardContent className="flex flex-col gap-2 px-4">
                    <Label className="mb-2 mt-8">More links</Label>
                    {communityLinks && communityLinks.length > 0 ? (
                        communityLinks.map((l) => (
                            <Link
                                href={l.url}
                                className="h-full p-0"
                                key={l.id}
                            >
                                {l.name}
                            </Link>
                        ))
                    ) : (
                        <>There is no more information about this community.</>
                    )}
                </CardContent>
            </Card>
        </>
    );
};
